import { Link } from 'react-router-dom'

const P = ({ children }: { children: React.ReactNode }) => (
  <p style={{ marginBottom: 10 }}>{children}</p>
)

const Ul = ({ items }: { items: string[] }) => (
  <ul style={{ paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 5, margin: '6px 0 12px' }}>
    {items.map(i => <li key={i} style={{ lineHeight: 1.65 }}>{i}</li>)}
  </ul>
)

const S = ({ n, title, children }: { n: string; title: string; children: React.ReactNode }) => (
  <div style={{ marginBottom: 28 }}>
    <h2 style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: '.88rem', color: 'var(--bill)', marginBottom: 8, paddingBottom: 7, borderBottom: '1px solid var(--edge)' }}>
      {n}. {title}
    </h2>
    <div style={{ fontFamily: 'Space Grotesk', fontSize: '.8rem', color: 'var(--muted)', lineHeight: 1.85 }}>
      {children}
    </div>
  </div>
)

export default function Privacy() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--ink)', paddingBottom: 80 }}>
      <div style={{ borderBottom: '1px solid var(--edge)', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ fontFamily: 'Syne', fontWeight: 900, fontSize: '1rem', color: 'var(--cash)', textDecoration: 'none', letterSpacing: '-0.03em' }}>Polywally</Link>
        <span style={{ color: 'var(--edge)' }}>·</span>
        <span style={{ fontFamily: 'Syne Mono', fontSize: '.6rem', color: 'var(--muted)', letterSpacing: '.1em', textTransform: 'uppercase' }}>Privacy Policy</span>
      </div>

      <div style={{ maxWidth: 640, margin: '0 auto', padding: '52px 24px 0' }}>
        <div style={{ marginBottom: 40 }}>
          <h1 style={{ fontFamily: 'Syne', fontWeight: 900, fontSize: '1.9rem', color: 'var(--bill)', letterSpacing: '-0.03em', marginBottom: 10 }}>Privacy Policy</h1>
          <div style={{ fontFamily: 'Syne Mono', fontSize: '.58rem', color: 'var(--muted)', opacity: .6 }}>
            Effective: February 2026 · <span style={{ color: 'var(--cash)' }}>privacy@polywally.com</span>
          </div>
        </div>

        <S n="1" title="Introduction">
          <P>
            Polywally ("we," "us," or "our") is committed to protecting your privacy. This policy explains what information we collect, how we use it, and who we share it with.
          </P>
        </S>

        <S n="2" title="What We Collect">
          <Ul items={[
            'Email address and display name, to create and manage your account',
            'Subscription status and billing period, managed via Stripe — we never see your card details',
            'Chart and options screenshots you upload, stored so you can access your analysis history',
            'Alpaca API keys you provide, stored encrypted, used only to proxy paper trading requests',
            'Monthly analysis count, used only to enforce plan limits',
          ]} />
        </S>

        <S n="3" title="How We Use It">
          <P>We use your information solely to provide and operate Polywally — including running AI analysis, managing your subscription, sending transactional emails, and maintaining platform security. We do not use your data for advertising or sell it to third parties.</P>
        </S>

        <S n="4" title="Who We Share It With">
          <P>We may share limited data with infrastructure providers — including payment processing, AI analysis services, cloud storage, and market data providers. These parties are bound by confidentiality and security obligations and are not permitted to use your data for any other purpose.</P>
        </S>

        <S n="5" title="How We Protect It">
          <P>All data is transmitted over HTTPS. Sensitive credentials are encrypted at rest. Passwords are hashed and never stored in plain text. We retain only what is necessary to operate the service.</P>
        </S>

        <S n="6" title="Educational Use Only">
          <P>Polywally is for educational and informational purposes only. Nothing on this platform constitutes financial, legal, or investment advice. Always conduct your own research or consult a licensed advisor before making investment decisions.</P>
        </S>

        <S n="7" title="Children">
          <P>Polywally is not intended for children under 13. We do not knowingly collect data from children. Contact us at <span style={{ color: 'var(--cash)' }}>privacy@polywally.com</span> if you believe this has occurred.</P>
        </S>

        <S n="8" title="Your Rights">
          <P>You may request access to, correction of, or deletion of your personal data at any time. To do so, email <span style={{ color: 'var(--cash)' }}>privacy@polywally.com</span> or delete your account directly from Settings.</P>
        </S>

        <S n="9" title="Changes">
          <P>We may update this policy from time to time. Any changes will be posted on this page with a revised effective date. Check back here to see if anything has changed. Continued use of Polywally after an update constitutes acceptance.</P>
        </S>

        <div style={{ marginTop: 44, paddingTop: 20, borderTop: '1px solid var(--edge)', display: 'flex', gap: 20, flexWrap: 'wrap', fontFamily: 'Syne Mono', fontSize: '.6rem' }}>
          <Link to="/" style={{ color: 'var(--cash)', textDecoration: 'none' }}>← Back to Polywally</Link>
          <Link to="/disclaimer" style={{ color: 'var(--muted)', textDecoration: 'none' }}>Disclaimer</Link>
        </div>
      </div>
    </div>
  )
}
